module.exports = __webpack_public_path__ + "static/media/placeholder-410px.0c954e17.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/placeholder-410px.svg
// module id = 768
// module chunks = 10